import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Adminnavbar from "../Adminnavbar";

export default function ViewBlog() {
  const { id } = useParams();

  const [loader, setLoader] = useState(true);
  const [blog, setBlog] = useState(null);

  // ================= GET BLOG DATA =================

  useEffect(() => {
    const getBlogData = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_BASE_URL}/blog/${id}`
        );

        if (res.status === 200) {
          setBlog(res.data.data);
        }
        setLoader(false);
      } catch (error) {
        console.error(error);
        setLoader(false);
      }
    };

    getBlogData();
  }, [id]);

  // ================= LOADER =================
  if (loader) {
    return (
      <>
        <Adminnavbar />
        <div className="page-wrapper">
          <div className="content text-center" style={{ padding: "100px" }}>
            Loading...
          </div>
        </div>
      </>
    );
  }

  // ================= NO DATA =================
  if (!blog) {
    return (
      <>
        <Adminnavbar />
        <div className="page-wrapper">
          <div className="content text-center" style={{ padding: "100px" }}>
            Blog not found
          </div>
        </div>
      </>
    );
  }

  // ================= UI =================
  return (
    <>
      <Adminnavbar />

      <div className="page-wrapper">
        <div className="content">
          {/* ===== BREADCRUMB ===== */}
          <nav
            aria-label="breadcrumb"
            style={{ "--bs-breadcrumb-divider": "none" }}
          >
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link> /
              </li>
              <li className="breadcrumb-item">
                <Link to="/knowledge-center-list">Knowledge Center</Link> /
              </li>
              <li className="breadcrumb-item active">View Knowledge Center</li>
            </ol>
          </nav>

          {/* ===== HEADER ===== */}
          <div className="content-page-header">
            <h5>View Knowledge Center</h5>
          </div>

          <div className="row">
            {/* TITLE */}
            <div className="col-lg-12 mb-3">
              <h3 style={{ fontWeight: "600" }}>{blog.title}</h3>
            </div>

            {/* DATE */}
            <div className="col-lg-12 mb-3">
              <p style={{ color: "#777" }}>
                Created on:{" "}
                {new Date(blog.created_at).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </p>
            </div>

            {/* IMAGE */}
            {blog.photo && (
              <div className="col-lg-12 mb-4">
                <img
                  src={`${process.env.REACT_APP_BACKEND_BASE_URL}/uploads/blog/${blog.photo}`}
                  alt={blog.title}
                  style={{
                    width: "100%",
                    maxWidth: "700px",
                    height: "350px",
                    objectFit: "cover",
                    borderRadius: "10px",
                    border: "1px solid #ddd",
                  }}
                />
              </div>
            )}

            {/* DESCRIPTION */}
            <div className="col-lg-12">
              <div
                style={{
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  border: "1px solid #eee",
                  lineHeight: "1.9",
                  fontSize: "15px",
                  color: "#333",
                  whiteSpace: "pre-line",
                }}
              >
                {blog.description}
              </div>
            </div>

            {/* BUTTON */}
            <div
              className="col-lg-12 mt-4"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Link to="/knowledge-center-list" className="btn btn-cancel">
                Back
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
